import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";

export default function CancelPaymentButton({ clickHandler }: { clickHandler?: () => void }) {
  const copies = useCopies();

  if (!clickHandler) return null;

  return (
    <Button
      label={copies.get("cancel")}
      isOutline
      onClick={clickHandler}
      className="paymentWrapper_btnWrapper--backButton"
    />
  );
}
